import React, {useState, useEffect} from 'react'
import MediaQuery from 'react-responsive'
import styles from './MeetingInfo.css'
import SelectPopup from '../../components/SelectPopup/SelectPopup'
import ToggleButton from '../../components/ToggleButton/ToggleButton'
import {fetchDepartmentsByDivision} from '../../api/departments'
import {fetchDepartmentEmployees} from '../../api/employees'
import styled from 'styled-components'
import SpinnerInput from '../../components/SpinnerInput/SpinnerInput'
import FieldLabel from '../../components/Form/FieldLabel'
import {_L, useLocaleState} from '../../context/LocaleContext'
import ErrorContainer from '../../components/ErrorContainer'

const MeetingInfo = ({dispatch, errors, meeting, user}) => {
  const [departments, setDepartments] = useState([])
  const [employees, setEmployees] = useState([])
  const localeState = useLocaleState()
  const {
    department,
    organizer,
    isPrivate,
    name,
    attendeesInRoom,
    room
  } = meeting

  const {maxCapacity} = room

  useEffect(
    () => {
      const {dv_id: dvId, dp_id: dpId} = user
      fetchDepartmentsByDivision({
        dvId,
        dpId
      }).then(departments => {
        setDepartments(departments)
      })
    },
    [user]
  )

  useEffect(
    () => {
      const {dvId, dpId} = department
      fetchDepartmentEmployees({
        dvId,
        dpId
      }).then(employees => {
        setEmployees(employees)
      })
    },
    [department]
  )

  const onChangeCounter = value =>
    dispatch({
      type: 'setMeeting',
      payload: {
        attendeesInRoom: value
      }
    })

  const onChangeToggle = isPrivate =>
    dispatch({
      type: 'setMeeting',
      payload: {
        isPrivate
      }
    })

  const onChangeName = event => {
    dispatch({
      type: 'setMeeting',
      payload: {
        name: event.target.value
      }
    })
  }

  const onSelectDepartment = ({dvId, dpId, deptCode}) =>
    dispatch({
      type: 'setMeeting',
      payload: {
        department: {
          dvId,
          dpId,
          deptCode
        }
      }
    })

  const onSelectOrganizer = ({emId, email, phone}) =>
    dispatch({
      type: 'setMeeting',
      payload: {
        organizer: {
          em_id: emId,
          email,
          phone
        }
      }
    })

  // TODO: the code below has duplication; refactor using CSS grid and styled components
  return (
    <MediaQuery maxDeviceWidth={768}>
      {matches => {
        if (matches) {
          return (
            <Container>
              <MeetingInfoTitle>
                {_L({key: 'Input Meeting Info', localeState})}
              </MeetingInfoTitle>
              <div className={styles.containerForm}>
                <div className={styles.formLine}>
                  <div style={{width: '100%', height: '100%'}}>
                    <FieldLabel>
                      {_L({key: 'Meeting Name', localeState})}
                    </FieldLabel>
                    <input
                      type="text"
                      className={styles.bkgInput}
                      defaultValue={name}
                      maxLength={60}
                      onChange={onChangeName}
                    />
                    <ErrorContainer errorMessage={errors.name} />
                  </div>
                </div>
                <div className={styles.formLine}>
                  <div className={styles.formLine2}>
                    <FieldLabel>
                      {_L({key: 'Keep meeting details private', localeState})}
                    </FieldLabel>
                    <ToggleButton value={isPrivate} onChange={onChangeToggle} />
                  </div>
                </div>
                <div className={styles.formLine}>
                  <div>
                    <FieldLabel>
                      {_L({key: 'Attendees', localeState})}
                    </FieldLabel>
                    <SpinnerInput
                      value={attendeesInRoom}
                      onChange={onChangeCounter}
                      min={0}
                      max={maxCapacity || 0}
                    />
                  </div>
                </div>
                <div className={styles.formLine}>
                  <div className={styles.formLineField}>
                    <FieldLabel>
                      {_L({key: 'Department', localeState})}
                    </FieldLabel>
                    <SelectPopup
                      options={departments}
                      displayField="name"
                      valueField="deptCode"
                      value={department.deptCode}
                      onSelect={onSelectDepartment}
                    />
                    <ErrorContainer errorMessage={errors.department} />
                  </div>
                </div>
                <div className={styles.formLine}>
                  <div className={styles.formLineField}>
                    <FieldLabel>
                      {_L({key: 'Organizer', localeState})}
                    </FieldLabel>
                    <SelectPopup
                      options={employees}
                      value={organizer.em_id}
                      displayField={'name'}
                      valueField={'emId'}
                      onSelect={onSelectOrganizer}
                    />
                    <ErrorContainer errorMessage={errors.organizer} />
                  </div>
                </div>
              </div>
            </Container>
          )
        } else {
          return (
            <Container>
              <MeetingInfoTitle>
                {_L({key: 'Input Meeting Info', localeState})}
              </MeetingInfoTitle>
              <div className={styles.containerForm}>
                <div className={styles.formLine}>
                  <div style={{width: '100%', height: '100%'}}>
                    <FieldLabel>
                      {_L({key: 'Meeting Name', localeState})}
                    </FieldLabel>
                    <input
                      type={'text'}
                      className={styles.bkgInput}
                      defaultValue={name}
                      maxLength={60}
                      onChange={onChangeName}
                    />
                    <ErrorContainer errorMessage={errors.name} />
                  </div>
                  <div style={{paddingLeft: 40}}>
                    <FieldLabel>
                      {_L({key: 'Attendees', localeState})}
                    </FieldLabel>
                    <SpinnerInput
                      value={attendeesInRoom}
                      onChange={onChangeCounter}
                      min={0}
                      max={maxCapacity || 0}
                    />
                  </div>
                </div>
                <div className={styles.formLine}>
                  <div style={{width: '50%', height: '100%'}}>
                    <FieldLabel>
                      {_L({key: 'Department', localeState})}
                    </FieldLabel>
                    <SelectPopup
                      value={department.deptCode}
                      options={departments}
                      displayField="name"
                      valueField="deptCode"
                      onSelect={onSelectDepartment}
                    />
                    <ErrorContainer errorMessage={errors.department} />
                  </div>
                  <div className={styles.formLine2}>
                    <FieldLabel>
                      {_L({key: 'Keep meeting details private', localeState})}
                    </FieldLabel>
                    <ToggleButton
                      style={{marginLeft: 'auto'}}
                      value={isPrivate}
                      onChange={onChangeToggle}
                    />
                  </div>
                </div>
                <div className={styles.formLine}>
                  <div style={{width: '50%', height: '100%'}}>
                    <FieldLabel>
                      {_L({key: 'Organizer', localeState})}
                    </FieldLabel>
                    <SelectPopup
                      options={employees}
                      value={organizer.em_id}
                      displayField={'name'}
                      valueField={'emId'}
                      onSelect={onSelectOrganizer}
                    />
                    <ErrorContainer errorMessage={errors.organizer} />
                  </div>
                </div>
              </div>
            </Container>
          )
        }
      }}
    </MediaQuery>
  )
}

export default MeetingInfo

const Container = styled.div`
  padding: 20px 30px 0 30px;

  @media (max-width: 420px) {
    padding: 20px 0 0 0;
  }
`

const MeetingInfoTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #a4a9b7;

  @media (max-width: 420px) {
    padding-left: 30px;
  }
`
